/*
 * @Author: Merlin
 * @Date: 2024-12-24 15:26:22
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-12 13:56:25
 * @Description: 
 */
import { useGameListSocket } from '@/socket/gamelist/index';
import { oGameName2Api } from '@/common/js/gameAbout';

const { EMIT_GET_GAME_CONFIG } = useGameListSocket();

/**
 * 返回 roulette 游戏的配置信息  
 * @returns Promise<any> 
 */
export const fnGetRouletteConfig = ()=>{
    const {
        oPromise,
        resolve,
        reject,
    } = createPromise();
    
    EMIT_GET_GAME_CONFIG(
        {game: oGameName2Api.rouletteGame},
        (oData)=>{
            if (!oData || oData.error) {
                reject(oData?.error || '查询游戏配置失败'); 
            }else{
                // console.log('roulette 游戏配置', deepCopy(oData));
                resolve(oData);
            }
        }
    );
    return oPromise; 
}


/**
 * 返回 roulette 游戏某项押注的中奖信息 
 * @returns number
 */
export const fnGetMulti = (
    coefficients,
    cells,
)=>{
    if (!coefficients || !cells) {
        return;
    }
    let iResult = 0;
    const {length, '0': firstOne} = cells;
    if (typeof firstOne === 'string'){
        if (length != 1) console.error('投注信息异常'); 
        iResult = coefficients[firstOne];
    }else if (typeof firstOne === 'number'){
        iResult = coefficients[length];
    }else{
        console.error('倍数查询异常');
    }
    return iResult;
};


// 下注布局的读取与记忆功能 
export const fnChipsManager = (
    type: 'get'|'set',
    aOptionList=[],
)=>{
    // ↓ 此值不宜修改
    const sKey = 'rouletteChipsHistory';
    if (type === 'get') {
        const sRecord = localStorage.getItem(sKey);
        try{
            const aResult = JSON.parse(sRecord || '[]');
            if (import.meta.dev){
                console.log('roulette record get', deepCopy(aResult)); 
            }
            return aResult;
        }catch(err){
            console.log('read record error'); 
        }
    }
    if (type != 'set') return; 
    const aList = aOptionList.filter(oCur => {
        return oCur.placed > 0;
    });
    if (!aList.length) return; 
    if (import.meta.dev){
        console.log('roulette record set', deepCopy(aList)); 
    }
    const sRecord = JSON.stringify(aList);
    localStorage.setItem(sKey, sRecord);
}


